/* ******************************** */
/* ****** snFunction for Vue3 ***** */
/* Current: v. 1.1 - 20230308
 * 
 * Hystory
 * v. 1.1 - 20230308
 * - Aggiunta EvidenziaTesto()


*/
/* ******************************** */

export default class snFunctions {

    /// Funzione per formattazione date
    static dateFormat(data, formato) { 
        //formato: 
        // dd = giorno, MM = mese, yyyy = anno full/ yy= anno 2 digit
        // separatori: - oppure /
        if(formato == undefined) formato = "dd/MM/yyyy";

        //Determina il separatore
        
        let separatore = "-";
        if(formato.indexOf("/")>=0) separatore = "/";
        let aFormat = formato.split(separatore);
        let res = "";
        try {
            data = new Date(data); //conversione esplicita per evitare scazzi con casti di stringhe
            for(let i=0; i<aFormat.length; i++) {
                if(aFormat[i] == "dd") { 
                    res += this.fillNumero(data.getDate(), 2);
                    if(i != aFormat.length -1) res += separatore;
                }
                if(aFormat[i] == "MM") { 
                    res += this.fillNumero(data.getMonth() + 1, 2);
                    if(i != aFormat.length -1) res += separatore;
                }
                if(aFormat[i] == "yyyy") { 
                    res += data.getFullYear();
                    if(i != aFormat.length -1) res += separatore;
                }
                if(aFormat[i] == "yy") { 
                    res += data.getYear();
                    if(i != aFormat.length -1) res += separatore;
                }
            }

        } catch (ex) {
            console.log(ex);
        }
        
        return res;
    }

    /// Funzione per formattazione ora
    static hourFormat(data, formato) {
        //formato: 
        // HH= ore, mm = minuti, ss = secondi
        // separatore :
        if(formato == undefined) formato = "HH:mm:ss";

        let aFormat = formato.split(":");
        let res = "";
        try {
            data = new Date(data); //conversione esplicita per evitare scazzi con casti di stringhe
            for(let i=0; i<aFormat.length; i++) {
                if(aFormat[i] == "HH") { 
                    res += this.fillNumero(data.getHours(), 2);
                    if(i != aFormat.length -1) res += ":";
                }
                if(aFormat[i] == "mm") { 
                    res += this.fillNumero(data.getMinutes(), 2);
                    if(i != aFormat.length -1) res += ":";
                }
                if(aFormat[i] == "ss") { 
                    res += this.fillNumero(data.getSeconds(), 2);
                    if(i != aFormat.length -1) res += ":";
                }
                
            }

        } catch (ex) {
            console.log(ex);
        }
        
        return res;

    }

    /// Funzione per riempire di zeri davanti ad un numero
    static fillNumero(numero, padding) {
        if(padding == undefined) padding = 2;
        return numero.toString().padStart(padding, '0');
    }

    /// Funzione Evidenzia testo passato
    static EvidenziaTesto(testo, daEvidenziare, spanClass) {
        if (spanClass == undefined) spanClass = "spn-evidenziato";
        let res;

        let firstHit = testo.toLowerCase().indexOf(daEvidenziare.toLowerCase());
        if ( firstHit >= 0) {            
            let estratto = testo.substring(firstHit, firstHit + daEvidenziare.length);
            let sostituzione = "<span title='" + firstHit + ' ' + daEvidenziare.length + "' class=\"" + spanClass + "\">" + estratto + "</span>";
            res = testo.replace(estratto, sostituzione);
            
        }
        else {
            res = testo;
        }

        
        return res;
    }

    

    /* METODI PRIVATI */
    /* ****************************** */

    

}